// File: /src/components/TableSortHeader.js

import React from 'react';

const TableSortHeader = ({ label, sortKey, currentSortConfig, onSort }) => {
	const isActive = currentSortConfig.key === sortKey;
	const direction = isActive ? currentSortConfig.direction : '';

	return (
		<th onClick={() => onSort(sortKey)}>
			{label} {isActive && (direction === 'asc' ? '▲' : '▼')}
		</th>
	);
};

export default TableSortHeader;
